import {
  ArrowElbowDownRight,
  CurrencyInr,
  Package,
} from "@phosphor-icons/react"
import {
  Card,
  Checkbox,
  Divider,
  MenuDivider,
  RadioGroup,
} from "@vesatogo/grass-core"
import classNames from "classnames"
import { HTMLAttributes, useState } from "react"
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom"
import { TradeKinds } from "~/constants/Kinds"
import { PattiTimeline } from "../../../../components/PattiTimeline"

interface ISidebarItemProps extends HTMLAttributes<HTMLDivElement> {
  active?: boolean
}

export function SideBarItem({
  active,
  className,
  ...props
}: ISidebarItemProps) {
  return (
    <div
      className={classNames(
        className,
        "flex justify-between items-center border-y px-4 py-2 text-green-600 hover:shadow-md transition-all",
        active ? "bg-green-100 font-600" : "hover:bg-green-50"
      )}
      {...props}
    />
  )
}

export function SideBar({
  id,
  kind,
  disableNew,
  storagePattis,
  demandId,
  offerId,
  allOffers,
}: {
  id?: number
  kind: string
  disableNew?: boolean
  storagePattis?: any
  demandId?: any
  offerId?: any
  allOffers?: any
}) {
  const params = useParams()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  // const [{ data }] = useFinalTradeListQuery({
  //   variables: { parentId: id },
  //   pause: !id,
  //   requestPolicy: "network-only",
  // })
  const createOrder = searchParams.get("type") === TradeKinds.OrderPatti
  const createOffer = searchParams.get("type") === "offer"
  const createSauda = searchParams.get("type") === TradeKinds.SaudaPavti

  const [selectedOrder, setSelectedOrder] = useState<string>(
    id?.toString() || ""
  )

  return allOffers?.length ? (
    <Card className="border w-full md:flex-[0_0_300px] rounded-lg overflow-hidden self-start bg-white">
      {allOffers?.map((offer: any) => {
        return (
          <Card className="mb-4 !shadow-none">
            <SideBarItem className="">
              <Link
                to={`/d/patti/${offer?.id}?type=offer`}
                className="flex-1 flex justify-between items-center"
              >
                <span>Offer Patti - #{offer?.id}</span>
              </Link>
            </SideBarItem>

            <div className="p-3">
              <RadioGroup
                vertical
                className="w-full gap-2"
                value={selectedOrder}
                onChange={value => {
                  navigate(`/d/trade-requests/${value}?new=true`)
                }}
              >
                {offer?.trades?.map(order => {
                  const rate = order?.trade_items?.[0]?.rate || 0
                  const quantity = order?.total_quantity || 0
                  const sellerName =
                    order?.seller?.user?.[0]?.full_name || "Unknown Seller"
                  const buyerName =
                    order?.buyer?.user?.[0]?.full_name || "Unknown Buyer"
                  const isActive = order.id.toString() === selectedOrder
                  return (
                    <Checkbox
                      key={order.id}
                      type="radio"
                      value={order.id.toString()}
                      className="!border-1 !border-gray-300 rounded-lg p-3 transition-all"
                      checked={isActive}
                      labelClassName={classNames(
                        "border border-gray-300 p-4 rounded-md",
                        isActive ? "border-green-400" : ""
                      )}
                      checkMarkClassName="mt-4 ml-2"
                    >
                      <div className="flex flex-col gap-2 w-full">
                        <div className="flex items-center gap-2">
                          <span className="w-2 h-2 rounded-full bg-green-500"></span>
                          <span className="font-600 text-[14px] text-green-600">
                            Order Patti - #{order.id}
                          </span>
                        </div>

                        {/* Seller & Buyer Info */}
                        <div className="text-xs !text-gray-800">
                          <div>Seller: {sellerName}</div>
                          <div>Buyer: {buyerName}</div>
                        </div>

                        <MenuDivider className="!m-0 !border-gray-300" />

                        {/* Quantity and Rate */}
                        <div className="flex items-center gap-2 text-xs text-brown-400 font-600">
                          <div className="flex gap-1">
                            <Package size={14} />
                            {quantity} kg
                          </div>
                          <Divider vertical />
                          <div className="flex gap-1">
                            <CurrencyInr size={14} />
                            {rate}/kg
                          </div>
                        </div>
                      </div>
                    </Checkbox>
                  )
                })}
              </RadioGroup>
            </div>
          </Card>
        )
      })}
    </Card>
  ) : id ? (
    <Card className="border w-full md:flex-[0_0_300px] rounded-lg overflow-hidden self-start bg-white p-4">
      <div className="flex flex-col">
        <span className="flex items-center text-base text-gray-700 font-600 mb-4">
          Trade Flow{" "}
          <span className="text-gray-500 text-sm font-400 ml-2">
            (Patti Journey Timeline)
          </span>
        </span>
        <PattiTimeline tradeId={id} isSidebar />
      </div>

      <div className="mt-4">
        {searchParams.get("new") ? (
          <SideBarItem active={true}>
            <div className="flex gap-2 items-center">
              <ArrowElbowDownRight className="text-gray-600" size={20} />
              New Hishob Patti
            </div>
          </SideBarItem>
        ) : null}

        {searchParams.get("newInward") ? (
          <SideBarItem active={true}>
            <div className="flex gap-2 items-center">
              <ArrowElbowDownRight className="text-gray-600" size={20} />
              New Inward Patti
            </div>
          </SideBarItem>
        ) : null}
        {searchParams.get("newBooking") ? (
          <SideBarItem active={true}>
            <div className="flex gap-2 items-center">
              <ArrowElbowDownRight className="text-gray-600" size={20} />
              New Transit Patti
            </div>
          </SideBarItem>
        ) : null}

        {searchParams.get("newStorage") ? (
          <SideBarItem active={true}>
            <div className="flex gap-2 items-center">
              <ArrowElbowDownRight className="text-gray-600" size={20} />
              New Storage Patti
            </div>
          </SideBarItem>
        ) : null}
      </div>
    </Card>
  ) : createOrder ? (
    <Card className="border w-full md:flex-[0_0_300px] rounded-lg overflow-hidden self-start">
      <SideBarItem
        className="border-green-200 bg-green-50"
        active={!searchParams.get("new") && id === Number(params.id)}
      >
        {/* Offer Patti - #{offerId} */}
        <Link
          to={`/d/stock-management/offer/${offerId}`}
          className="flex-1 block"
        >
          Offer Patti - #{offerId}
        </Link>
      </SideBarItem>
      {createOrder ? (
        <SideBarItem active={true} className="">
          <div className="flex gap-2 items-center">
            <ArrowElbowDownRight className="text-gray-600" size={20} />
            New Order Patti
          </div>
        </SideBarItem>
      ) : null}
    </Card>
  ) : demandId ? (
    <Card className="border w-full md:flex-[0_0_300px] rounded-lg overflow-hidden self-start">
      <SideBarItem className="border-green-200 bg-green-50">
        <Link
          to={`/d/stock-management/demand/${demandId}`}
          className="flex-1 block"
        >
          Demand Patti - #{demandId}
        </Link>
      </SideBarItem>
      {createSauda ? (
        <SideBarItem active={true} className="">
          <div className="flex gap-2 items-center">
            <ArrowElbowDownRight className="text-gray-600" size={20} />
            New Sauda Patti
          </div>
        </SideBarItem>
      ) : null}
    </Card>
  ) : createOffer && storagePattis?.length ? (
    <Card className="border w-full md:flex-[0_0_300px] rounded-lg overflow-hidden self-start">
      <SideBarItem className="border-green-200 bg-green-50">
        <Link to={`/d/stock-management`} className="flex-1 block">
          Storage Patti - {storagePattis?.map(item => `#${item.id}`).join(", ")}
        </Link>
      </SideBarItem>

      <SideBarItem active={true} className="">
        <div className="flex gap-2 items-center">
          <ArrowElbowDownRight className="text-gray-600" size={20} />
          New Offer Patti
        </div>
      </SideBarItem>
    </Card>
  ) : null
}
